<template>
  <div
    class="m-container"
    :class="{
      'm-container--gutter': gutter === 'default',
      [`m-container--size-${size}`]: size !== 'md',
    }"
  >
    <slot />
  </div>
</template>

<script>
/**
 * Sets the max content width, with optional gutter if this is the outermost
 * container.
 */
export default {
  name: 'MContainer',
  props: {
    /**
     * Add padding left and right
     */
    gutter: {
      type: String,
      default: 'default',
      validator: (prop) => ['default', 'none'].includes(prop),
    },
    /**
     * How wide to set the max width
     */
    size: {
      type: String,
      default: 'md',
      validator: (prop) => ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'].includes(prop),
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../sass/framework/mixins/container';

.m-container {
  @include container.container;
  @include container.container--sizes;

  &--gutter {
    @include container.container--gutter;
  }
}
</style>
